import $ from "jquery"
import CryptoJS from "crypto-js";

class shareds {
    //物件建立時產生
    constructor(){
    }

    
    /**********
     * 檢查物件是否不存在
     * obj : any object
     */
    isEmpty = (obj) => {
        if(
            typeof obj == 'undefined'
            || obj == null
            || obj.length<=0
        ){
            return true;
        }
        return false;
    }
    //  判斷是否為空物件
    isEmptyObject(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getImageStyle(image) {
        return {
            backgroundImage: `url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            // 您可以添加更多樣式
        };
    }

    containSpecial(str) {
        const szMsg = "[#%&;\"/',;:=!^]"; 
        let alertStr = ""; 
    
        for (let i = 0; i < szMsg.length; i++) {
            if (str.indexOf(szMsg[i]) > -1) {
                alertStr = "請勿包含非法字元如[#%&;\"/',;:=!^]";
                break;
            }
        } 
    
        if (alertStr != "") { 
            console.log(alertStr); 
            return false; 
        } 
    
        return true;
    }

    getAuuAccountData(){
        const userJson = localStorage.getItem('auu_user_info') ? localStorage.getItem('auu_user_info') : "{}"
        return userJson ? JSON.parse(userJson) : {}
    }

    getNextDayIfAfter1PM(inputDate = null) {
      let currentDate;
  
      // 如果有傳入日期時間，則使用傳入的日期，否則使用當前日期
      if (inputDate) {
          currentDate = new Date(inputDate);
          if (isNaN(currentDate.getTime())) {
              throw new Error("Invalid date format. Please use 'yyyy-mm-dd hh:ii:ss'.");
          }
      } else {
          currentDate = new Date(); // 沒有傳入時使用當前日期
      }
  
      const hour = currentDate.getHours(); // 取得當前小時
  
      // 檢查是否超過下午13:00
      if (hour >= 13) {
          currentDate.setDate(currentDate.getDate() + 1); // 如果超過，則將日期加一天
      }
  
      // 格式化日期為 "yyyy-mm-dd"
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份從0開始，所以+1
      const day = String(currentDate.getDate()).padStart(2, '0');
  
      return `${year}-${month}-${day}`;
    }
  

    addStepAndPlanBeignStepFormat(step_no, plan_beign_step) {
      // 將 stepString 轉換成整數
      let stepInt = parseInt(step_no, 10);
      // 與 planBeginStep 相加
      let result = stepInt + plan_beign_step;
      // 將結果格式化為2位數字符串，前面補0
      return result.toString().padStart(2, '0');
    }

    addBusinessDays(startDate, days) {
      const date = new Date(startDate);
  
      // 檢查起始日期是否為有效日期
      if (isNaN(date.getTime())) {
          throw new Error("Invalid start date");
      }
  
      let addedDays = 0;
  
      // 如果起始日期是工作日，則首先計入一天
      const startDayOfWeek = date.getDay();
      if (startDayOfWeek !== 0 && startDayOfWeek !== 6) {
          addedDays++;
      }
  
      // 開始從下一天計算剩餘的工作天數
      while (addedDays < days) {
          date.setDate(date.getDate() + 1); // 每次加一天
          const dayOfWeek = date.getDay();
  
          // 如果不是週六或週日，則計算為工作日
          if (dayOfWeek !== 0 && dayOfWeek !== 6) {
              addedDays++;
          }
      }
  
      // 使用 toLocaleDateString 確保日期格式正確 (yyyy-mm-dd)
      const formattedDate = date.toLocaleDateString('en-CA'); // 'en-CA' 格式為 yyyy-mm-dd
      return formattedDate;
    }

    //回傳日期 yyyy:mm:dd
    getCurrentDate() {
      //開發時要調用這個設定
      const setting = localStorage.getItem('wildone_dev_setting')
      const date = setting ? JSON.parse(setting).date : null
      if ( date ){
        return date
      }

      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
  
      return `${year}-${month}-${day}`;
  }

    calculateDate(startDate, daysToAdd, excludeWeekends = false) {
      const date = new Date(startDate);
      if (isNaN(date.getTime())) {
          throw new Error('Invalid date format. Expected yyyy-mm-dd.');
      }
  
      let daysProcessed = 0;
      const step = daysToAdd >= 0 ? 1 : -1; // 正數往前推，負數往回推
      const targetDays = Math.abs(daysToAdd);
  
      while (daysProcessed < targetDays) {
          date.setDate(date.getDate() + step);
          if (!excludeWeekends || (date.getDay() !== 0 && date.getDay() !== 6)) {
              daysProcessed++;
          }
      }
  
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
  
      return `${yyyy}-${mm}-${dd}`;
  }
  
    

    TAIWAN = [
        {
          city: "台北市",
          area: ["中正區", "大同區", "中山區", "松山區", "大安區", "萬華區", "信義區", "士林區", "北投區", "內湖區", "南港區", "文山區"]
        },
        {
          city: "新北市",
          area: ["板橋區", "三重區", "中和區", "永和區", "新莊區", "新店區", "土城區", "蘆洲區", "瑞芳區", "淡水區", "汐止區", "三峽區", "樹林區", "鶯歌區", "五股區", "泰山區", "林口區", "八里區", "平溪區", "雙溪區", "貢寮區", "金山區", "萬里區", "三芝區", "石門區"]
        },
        {
          city: "桃園市",
          area: ["桃園區", "中壢區", "平鎮區", "楊梅區", "蘆竹區", "大溪區", "大園區", "觀音區", "八德區", "龍潭區", "新屋區", "龜山區", "復興區"]
        },
        {
          city: "台中市",
          area: ["中區", "東區", "南區", "西區", "北區", "北屯區", "西屯區", "南屯區", "太平區", "大里區", "霧峰區", "烏日區", "豐原區", "后里區", "石岡區", "東勢區", "和平區", "新社區", "潭子區", "大雅區", "神岡區", "大肚區", "沙鹿區", "龍井區", "梧棲區", "清水區", "大甲區", "外埔區", "大安區"]
        },
        {
          city: "台南市",
          area: ["中西區", "東區", "南區", "北區", "安平區", "安南區", "永康區", "歸仁區", "新化區", "左鎮區", "玉井區", "楠西區", "南化區", "仁德區", "關廟區", "龍崎區", "官田區", "麻豆區", "佳里區", "西港區", "七股區", "將軍區", "學甲區", "北門區", "新營區", "後壁區", "白河區", "東山區", "六甲區", "下營區", "柳營區", "鹽水區", "善化區", "大內區", "山上區", "新市區", "安定區"]
        },
        {
          city: "高雄市",
          area: ["新興區", "前金區", "苓雅區", "鹽埕區", "鼓山區", "旗津區", "前鎮區", "三民區", "楠梓區", "小港區", "左營區", "仁武區", "大社區", "岡山區", "路竹區", "阿蓮區", "田寮區", "燕巢區", "橋頭區", "梓官區", "彌陀區", "永安區", "湖內區", "鳳山區", "大寮區", "林園區", "鳥松區", "大樹區", "旗山區", "美濃區", "六龜區", "內門區", "杉林區", "甲仙區", "桃源區", "那瑪夏區", "茂林區", "茄萣區"]
        },
        {
          city: "基隆市",
          area: ["中正區", "七堵區", "暖暖區", "仁愛區", "中山區", "安樂區", "信義區"]
        },
        {
          city: "新竹市",
          area: ["東區", "北區", "香山區"]
        },
        {
          city: "嘉義市",
          area: ["東區", "西區"]
        },
        {
          city: "新竹縣",
          area: ["竹北市", "竹東鎮", "新埔鎮", "關西鎮", "湖口鄉", "新豐鄉", "芎林鄉", "橫山鄉", "北埔鄉", "寶山鄉", "峨眉鄉", "尖石鄉", "五峰鄉"]
        },
        {
          city: "苗栗縣",
          area: ["苗栗市", "頭份市", "竹南鎮", "後龍鎮", "通霄鎮", "苑裡鎮", "卓蘭鎮", "造橋鄉", "西湖鄉", "頭屋鄉", "公館鄉", "銅鑼鄉", "三義鄉", "大湖鄉", "獅潭鄉", "三灣鄉", "南庄鄉", "泰安鄉"]
        },
        {
          city: "彰化縣",
          area: ["彰化市", "員林市", "和美鎮", "鹿港鎮", "溪湖鎮", "二林鎮", "田中鎮", "北斗鎮", "花壇鄉", "芬園鄉", "大村鄉", "永靖鄉", "伸港鄉", "線西鄉", "福興鄉", "秀水鄉", "埔心鄉", "埔鹽鄉", "大城鄉", "芳苑鄉", "竹塘鄉", "社頭鄉", "二水鄉", "田尾鄉", "埤頭鄉", "溪州鄉"]
        },
        {
          city: "南投縣",
          area: ["南投市", "埔里鎮", "草屯鎮", "竹山鎮", "集集鎮", "名間鄉", "鹿谷鄉", "中寮鄉", "魚池鄉", "國姓鄉", "水里鄉", "信義鄉", "仁愛鄉"]
        },
        {
          city: "雲林縣",
          area: ["斗六市", "斗南鎮", "虎尾鎮", "西螺鎮", "土庫鎮", "北港鎮", "莿桐鄉", "林內鄉", "古坑鄉", "大埤鄉", "崙背鄉", "二崙鄉", "麥寮鄉", "臺西鄉", "東勢鄉", "褒忠鄉", "四湖鄉", "口湖鄉", "水林鄉", "元長鄉"]
        },
        {
          city: "嘉義縣",
          area: ["太保市", "朴子市", "布袋鎮", "大林鎮", "民雄鄉", "溪口鄉", "新港鄉", "六腳鄉", "東石鄉", "義竹鄉", "鹿草鄉", "水上鄉", "中埔鄉", "竹崎鄉", "梅山鄉", "番路鄉", "大埔鄉", "阿里山鄉"]
        },
        {
          city: "屏東縣",
          area: ["屏東市", "潮州鎮", "東港鎮", "恆春鎮", "萬丹鄉", "長治鄉", "麟洛鄉", "九如鄉", "里港鄉", "鹽埔鄉", "高樹鄉", "萬巒鄉", "內埔鄉", "竹田鄉", "新埤鄉", "枋寮鄉", "新園鄉", "崁頂鄉", "林邊鄉", "南州鄉", "佳冬鄉", "琉球鄉", "車城鄉", "滿州鄉", "枋山鄉", "三地門鄉", "霧臺鄉", "瑪家鄉", "泰武鄉", "來義鄉", "春日鄉", "獅子鄉", "牡丹鄉"]
        },
        {
          city: "宜蘭縣",
          area: ["宜蘭市", "羅東鎮", "蘇澳鎮", "頭城鎮", "礁溪鄉", "壯圍鄉", "員山鄉", "冬山鄉", "五結鄉", "三星鄉", "大同鄉", "南澳鄉"]
        },
        {
          city: "花蓮縣",
          area: ["花蓮市", "鳳林鎮", "玉里鎮", "新城鄉", "吉安鄉", "壽豐鄉", "秀林鄉", "光復鄉", "豐濱鄉", "瑞穗鄉", "萬榮鄉", "富里鄉"]
        },
        {
          city: "台東縣",
          area: ["台東市", "成功鎮", "關山鎮", "卑南鄉", "鹿野鄉", "池上鄉", "東河鄉", "長濱鄉", "太麻里鄉", "大武鄉", "綠島鄉", "海端鄉", "延平鄉", "金峰鄉", "達仁鄉", "蘭嶼鄉"]
        },
        {
          city: "澎湖縣",
          area: ["馬公市", "湖西鄉", "白沙鄉", "西嶼鄉", "望安鄉", "七美鄉"]
        },
        {
          city: "金門縣",
          area: ["金城鎮", "金湖鎮", "金沙鎮", "金寧鄉", "烈嶼鄉", "烏坵鄉"]
        },
        {
          city: "連江縣",
          area: ["南竿鄉", "北竿鄉", "莒光鄉", "東引鄉"]
        }
    ]

}
export default shareds